/**
 * Tiny module-level signal shared between the re-auth flow (reauth.tsx) and
 * useAuth.ts — kept in its own file so neither module imports the other.
 *
 * Why this exists (ADR-063): MFA step-up re-authentication has to advance the
 * Cognito `auth_time` claim, and the only way to do that is a fresh sign-in
 * event (a token refresh does NOT advance auth_time — that is the original
 * defect ADR-063 fixes). Amplify's `signIn()` throws if a user is already
 * authenticated, so the step-up must `signOut()` first. That sign-out emits a
 * Hub `signedOut` event which useAuth would normally treat as "unauthenticated"
 * → AuthenticatedRoute redirects to /signin → the whole page (and the operator's
 * in-progress action) unmounts.
 *
 * To keep the page mounted across the transient signOut→signIn, the re-auth
 * flow raises this flag for the duration of the step-up. While it is set,
 * useAuth IGNORES the transient `signedOut` event. The subsequent `signedIn`
 * event (which is NOT suppressed) restores the authenticated state cleanly.
 */
let reauthInProgress = false;

export function setReauthInProgress(value: boolean): void {
  reauthInProgress = value;
}

export function isReauthInProgress(): boolean {
  return reauthInProgress;
}
